import React from 'react'
import useOperation from '../hooks/use-operation'
import { useOnConstrain } from '@morningtrain/react-filters'

function ExecuteOperationOnConstrain (props) {
  const operation = useOperation()

  useOnConstrain((constraints) => {
    if (operation) {
      operation.constrain(constraints)
    }
  })

  return null
}

export default ExecuteOperationOnConstrain
